import { APP_ENV, ORG_NAME } from 'utils/env'

export const createItemImageUrl = (productSku) => {
  const orgName = ORG_NAME
  const env = APP_ENV
  const timeStamp = new Date().valueOf()

  // if we are in prd environment, we don't need to add the env to the url
  if (env === 'prd') {
    return `https://d1hgunbs8ulpw7.cloudfront.net/${orgName}/item/${productSku}.webp?${timeStamp}`
  }

  return `https://d1hgunbs8ulpw7.cloudfront.net/${orgName}/${env}_item/${productSku}.webp?${timeStamp}`
}
